import { useState } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";
import { useAlert } from "advancement-solutions-components/dist/providers";

export const useReconcileBibsAsJob = () => {
  const { authApi } = useApi();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { send } = useAlert();

  const startJob = async (batchId) => {
    try {
      setIsUpdating(true);
      setError(null);
      const response = await authApi.post(`/api/bibs/reconcile/job`, {
        batchId,
      });
      setData(response.data);
      send({ message: `Job ${response.data.id} submitted.`, severity: "info" });
    } catch (e) {
      const error = wrapError(e);
      send({
        message: `BIB reconcile Job was not completed: ${error.message}`,
        severity: "error",
      });
      setError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return [data, startJob, isUpdating, error];
};

export default useReconcileBibsAsJob;
